$(document).ready(function () {
  if (window.innerWidth >= 992) {
    AOS.init({
      once: true,
      disable: function () {
        var maxWidth = 992;
        return window.innerWidth < maxWidth;
      }
    });
  }
});
$(document).one('scroll touchstart mouseenter', function () {
  if (window.scriptsRunned) {
    return;
  }
  $(document).on('scroll', function (e) {
    AOS.refresh();
  });
  window.scriptsRunned = true;
  if ($('.latest-content-slider').length) {
    $('.latest-content-slider').slick({
      /*centerMode: true,*/
      centerPadding: '0',
      slidesToShow: 3,
      arrows: false,
      loop: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      pauseOnFocus: false,
      cssEase: 'ease-out',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 320,
          settings: {
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1
          }
        }
      ]
    });
    $('.slider-prev-button').click(function () {
      $('.latest-content-slider').slick('slickPrev');
    });

    $('.slider-next-button').click(function () {
      $('.latest-content-slider').slick('slickNext');
    });
  }
  if ($('.carousel-slider').length) {
    $('.carousel-slider').slick({
      /*centerMode: true,*/
      centerPadding: '0',
      slidesToShow: 3,
      arrows: false,
      loop: true,
      autoplay: true,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      pauseOnFocus: false,
      cssEase: 'ease-out',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 320,
          settings: {
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1
          }
        }
      ]
    });
    $('.custom-carousel .slider-prev-button').click(function () {
      $('.carousel-slider').slick('slickPrev');
    });

    $('.custom-carousel .slider-next-button').click(function () {
      $('.carousel-slider').slick('slickNext');
    });
    $('.custom-carousel').on('click', '.carousel-item.popup', function(e) {
      e.preventDefault();
      var element = this;
      $($(element).data('target')).find('.modal-body').html(JSON.parse($(element).data('popcontent')));
      setTimeout(function(element) {
        $($(element).data('target')).modal('show');
      }, 1000, element);
    });
  }
  $('.custom-carousel .modal').on('hidden.bs.modal', function (e) {
    $(this).find('.modal-body').html('');
  });
  if ($('.testimonials-slider').length) {
    $('.testimonials-slider').slick({
      /*centerMode: true,*/
      centerPadding: '0',
      slidesToShow: 3,
      arrows: false,
      loop: true,
      autoplay: true,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      pauseOnFocus: false,
      cssEase: 'ease-out',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: false,
            centerPadding: '0',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1
          }
        }
      ]
    });
    $('.testimonials .slider-prev-button').click(function () {
      $('.testimonials-slider').slick('slickPrev');
    });

    $('.testimonials .slider-next-button').click(function () {
      $('.testimonials-slider').slick('slickNext');
    });
  }
  if ($('.logos-slider-container').length) {
    $('.logos-slider').slick({
      /*centerMode: true,*/
      centerPadding: '0',
      slidesToShow: 4,
      arrows: false,
      loop: true,
      autoplay: true,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      pauseOnFocus: false,
      cssEase: 'ease-out',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1
          }
        }
      ]
    });
    $('.logos-slider, .carousel-slider, .testimonials-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.logos-slider').find('img.lazy').each(function () {
        if (!$(this).hasClass('loaded')) {
          $(this).attr('src', $(this).data('src')).addClass('loaded');
          if ($(this).parent()[0].tagName == 'PICTURE') {
            $(this).parent().find('[data-srcset]').each(function () {
              $(this).attr('srcset', $(this).data('srcset'));
            });
          }
        }
      });
    });
  }
  if ($('#animation_container').length) {
    if ($('#animation_container').hasClass('animation-1')) {
      $.getScript(window.location.protocol + '//' + window.location.host + '/wp-content/themes/nmi/jsmin/NMI_Modular_Dots_15sec.min.js', function () {
        $(window).trigger('scriptload')
      });
    }
    if ($('#animation_container').hasClass('animation-2')) {
      $.getScript(window.location.protocol + '//' + window.location.host + '/wp-content/themes/nmi/jsmin/NMI_Modular_Dots_15sec_MRN.min.js', function () {
        $(window).trigger('scriptload')
      });
    }
  }

  if ($('.careers-tabs').length) {
    $(".careers-tabs .nav-tabs .nav-link").click(function (e) {
      e.preventDefault();
      $('.careers-tabs .nav-tabs .nav-link').removeClass('active');
      $('.careers-tabs .tab-content .tab-pane').removeClass('active');
      $(this).addClass('active');
      $($(this).attr('href')).addClass('active');
    });
  }
  if ($('#bs-talk-to-our-team').length) {
    irisValidation($('#bs-talk-to-our-team'), {
      focusFirstInput: false,
      validators: {
        firstname: 'firstname',
        lastname: 'lastname',
        email: 'email',
        company: 'company',
      },
      filters: {
        conversion_url: 'page_url',
        pagename: 'page_url',
        utm_source: 'utm_param',
        utm_campaign: 'utm_param',
        utm_medium: 'utm_param',
        utm_content: 'utm_param',
        utm_term: 'utm_param',
        gclid: 'utm_param',
        additionaldata: 'utm_param',
        merchant: 'utm_param',
        message: 'utm_param',
        utm_adgroup: 'utm_param',
        utm_campaignid: 'utm_param',
        utm_creative: 'utm_param',
        utm_device: 'utm_param',
        utm_keyword: 'utm_param',
        utm_network: 'utm_param',
        utm_targetid: 'utm_param',
        channel_type: 'utm_param',
        fbclid: 'utm_param',
        msclkid: 'utm_param',
        sfcid: 'utm_param',
        li_fat_id: 'utm_param',
        utm_lp: 'utm_param',
        last_referrer: 'utm_param',
        ft_sfcid: 'utm_param',
        utm_matchtype: 'utm_param',
        ft_gclid: 'utm_param',
        ft_li_fat_id: 'utm_param',
        ft_msclkid: 'utm_param',
        ft_fbclid: 'utm_param',
        ft_utm_campaign: 'utm_param',
        ft_utm_content: 'utm_param',
        ft_utm_term: 'utm_param',
        ft_utm_source: 'utm_param',
        ft_utm_medium: 'utm_param',
        ft_utm_adgroupid: 'utm_param',
        ft_utm_creative: 'utm_param',
        ft_utm_device: 'utm_param',
        ft_utm_keyword: 'utm_param',
        ft_utm_network: 'utm_param',
        ft_utm_matchtype: 'utm_param',
        ft_utm_campaignid: 'utm_param',
        ft_utm_targetid: 'utm_param',
        ft_channel_type: 'utm_param',
        ft_referrer: 'utm_param',
        ft_lp: 'utm_param',
        utm_adgroupid: 'utm_param',
        lt_lp: 'utm_param',
        lt_Referrer: 'utm_param',
        lt_sfcid: 'utm_param',
      },
      validateByTimeout: ['email'],
      errorMessages: {
        required: 'This field is required',
        emailFormat: 'Not a valid email',
        connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
      },
      success: function (data) {
        var currentForm = $('#bs-talk-to-our-team').data('irisFormValidator');
        var form = document.createElement("form");
        var cpRouter = 'paid';
        if ($('#cpRouter').length && $('#cpRouter').val().length) {
          cpRouter = $('#cpRouter').val();
        }
        form.id = "postform";
        form.name = "postform";
        form.action = "https://tools.forchili.com/pardot/api/v1/success/nmi/" + cpRouter + "?successLocation=" + location.protocol + '//' + location.host + "/thank-you/";
        form.method = "post";
        form.style = "display: none";
        var formData = currentForm.getFormData();
        Object.keys(formData).forEach(function (key) {
          if ((['conversion_url', 'additionaldata', 'pagename', 'token', 'utm_campaign', 'utm_content', 'utm_gclid', 'utm_medium', 'utm_source', 'utm_term']).indexOf(key) == -1) {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = formData[key];
            form.appendChild(input);
          }
        });
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    });
  }
  $('.tab-link').click(function(e) {
    $(this).toggleClass('opened');
  })
  $('.block-read-more').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).parents('.has-more').toggleClass('opened');
  });
});
